import { useQuery } from '@eika-infrastruktur/react-query';

import { isRiskyDevice } from '../services/riskyDeviceService';

export const useRiskyDeviceCheck = (enableBlockRiskyDevicePaymentLimit: boolean) => {
    const { data, isLoading } = useQuery<boolean>({
        queryKey: ['isRiskyDevice'],
        queryFn: isRiskyDevice,
        enabled: enableBlockRiskyDevicePaymentLimit,
    });

    return { isRiskyDevice: data, isLoading };
};
